/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useTransactionStore = defineStore("transaction", {
    actions: {
        async getNormalFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/normal";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getMigrationFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/migration";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getOutageFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/outage";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getOutageMigrationFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/outageMigration";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getLineFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/line";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

        async getSummaryFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/summary";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },


        async getGraphDataFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                fromDate: payload.fromDate,
                toDate: payload.toDate
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/tx/graph/data";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },

    },
});